import React, { useState } from 'react';
import { Form, Button, Card, message, Input } from 'antd';
import { ArrowLeftOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import { resetPassword } from "../../services/auth";

const ResetPassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { encodedUserId } = useParams();
  const userId = encodedUserId ? atob(encodedUserId) : '';
  const { verificationCode } = location.state || {};
  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await resetPassword({
        userId,
        newPassword: values.newPassword,
        code: verificationCode
      });
      message.success('Password reset successfully');
      setTimeout(() => {
          navigate('/signin');
      }, 1500);
    } catch (error) {
      console.log(error)
      message.error(error.response?.data?.error?.message || 'Failed to reset password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      background: '#EFF3F6',
      flex: 1,
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh"
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            backgroundColor: '#e6f7ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
          }}>
            <LockOutlined style={{ fontSize: 24, color: '#1890ff' }} />
          </div>
          <h2 style={{ margin: 0, color: '#1890ff' }}>Reset Password</h2>
        </div>

        <p style={{ marginBottom: '30px', color: '#666', textAlign: 'center' }}>
          Please enter your new password
        </p>

        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          requiredMark={false}
        >
          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[
              { required: true, message: 'Please enter your new password' },
              { min: 8, message: 'Password must be at least 8 characters long' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Enter new password"
              size="large"
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: 'Please confirm your password' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords do not match'));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Confirm new password"
              size="large"
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: '20px' }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={loading}
              block
              size="large"
            >
              Reset Password
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center' }}>
          <Button
            type="link"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(`/verify-code/${encodedUserId}`)}
            style={{ padding: 0 }}
          >
            Back to Verification
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default ResetPassword;